import _jsx from "@babel/runtime/helpers/jsx";
var _SubHeading, _div, _SubHeading2, _span, _Checkbox;
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Input, Textarea, Checkbox } from 'reaxl-forms';
import { SubHeading } from 'reaxl';
import TextAlert from '../../TextAlert/index.js';
function UpdateSavedSearchForm(_ref) {
  let {
    phone = '',
    bookmark = {}
  } = _ref;
  const [isTextAlertVisible, setIsTextAlertVisible] = useState(false);
  const handleAlertByText = event => {
    setIsTextAlertVisible(event.target.checked);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, _SubHeading || (_SubHeading = /*#__PURE__*/_jsx(SubHeading, {
    level: 3
  }, void 0, "Give Your Search a Name")), /*#__PURE__*/_jsx("div", {
    className: "margin-bottom-4 margin-top-2"
  }, void 0, /*#__PURE__*/_jsx(Input, {
    id: "bookmarkTitle",
    name: "bookmarkTitle",
    autoFocus: true,
    label: "Search Name",
    layout: "inside",
    value: bookmark.title,
    maxLength: "50",
    required: true
  })), _div || (_div = /*#__PURE__*/_jsx("div", {
    className: "margin-bottom-4 padding-top-1"
  }, void 0, /*#__PURE__*/_jsx(Textarea, {
    label: "Notes (optional)",
    placeholder: "Notes (optional)",
    layout: "inside",
    name: "bookmarkNotes"
  }))), /*#__PURE__*/_jsx("div", {
    className: "padding-top-1"
  }, void 0, _SubHeading2 || (_SubHeading2 = /*#__PURE__*/_jsx(SubHeading, {
    level: 3,
    htmlFor: "notify-me"
  }, void 0, "Don't miss out on new listings!")), _span || (_span = /*#__PURE__*/_jsx("span", {}, void 0, "How would you like to be notified when new listings match your search?")), /*#__PURE__*/_jsx("div", {
    className: "display-flex gap-5"
  }, void 0, _Checkbox || (_Checkbox = /*#__PURE__*/_jsx(Checkbox, {
    id: "alertByEmail",
    name: "alertByEmail",
    label: "Email",
    rootClasses: "margin-vertical"
  })), /*#__PURE__*/_jsx(Checkbox, {
    onChange: handleAlertByText,
    id: "alertByText",
    name: "alertByText",
    label: "Text",
    rootClasses: "margin-vertical"
  }))), isTextAlertVisible && /*#__PURE__*/_jsx(TextAlert, {
    phone: phone
  }));
}
export default /*#__PURE__*/React.memo(UpdateSavedSearchForm);